module.exports = __webpack_public_path__ + "img/pa.4e860f01.svg";